import { useNavigate } from "react-router-dom";
import { X, ChevronLeft } from "lucide-react";
import LogoMark from "@/components/LogoMark";

/**
 * PageHeader — small, trauma-informed header.
 * Always provides a clear exit (or back) for sensitive flows.
 */
export default function PageHeader({
  title,
  subtitle,
  onExit,
  exitTo = "/",
  exitLabel = "Exit",
  variant = "exit", // "exit" | "back" | "none"
  testid,
}) {
  const nav = useNavigate();

  const handleExit = () => {
    if (onExit) return onExit();
    if (variant === "back") nav(-1);
    else nav(exitTo);
  };

  return (
    <div className="flex items-start justify-between gap-4 mb-7">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-2">
          <LogoMark size={25} title="" />
          <p
            className="text-[9px] uppercase tracking-[0.34em]"
            style={{ color: "var(--un-text-3)", fontFamily: "Manrope, sans-serif" }}
          >
            UnAnonymous
          </p>
        </div>
        {title && (
          <h1
            className="text-[31px] sm:text-[34px] leading-[1.05] font-medium tracking-[-0.025em]"
            style={{ color: "var(--un-plum-deep)", fontFamily: "Lora, serif" }}
          >
            {title}
          </h1>
        )}
        {subtitle && (
          <p
            className="text-[14px] mt-2 leading-relaxed max-w-[360px]"
            style={{ color: "var(--un-text-2)" }}
          >
            {subtitle}
          </p>
        )}
      </div>
      {variant !== "none" && (
        <button
          type="button"
          onClick={handleExit}
          data-testid={testid}
          aria-label={exitLabel}
          className="shrink-0 flex items-center gap-1.5 px-3 py-2 rounded-full un-press text-xs font-medium"
          style={{
            background: "rgba(91,57,84,0.06)",
            color: "var(--un-text-2)",
            fontFamily: "Manrope, sans-serif",
          }}
        >
          {variant === "back" ? <ChevronLeft size={14} /> : <X size={14} />}
          {exitLabel}
        </button>
      )}
    </div>
  );
}
